// useClipboard composable — 클립보드 복사 (navigator.clipboard → execCommand fallback)
import { ref } from 'vue';

// @MX:SPEC: SPEC-ECOUNT-ETL-OPS-CONSOLE-001 REQ-OC-COMMON-007 (ux-patterns.md §12.3)

/**
 * 클립보드 composable
 * @returns {{ copy: (text: string) => Promise<boolean>, copying: Ref<boolean> }}
 */
export function useClipboard() {
  const copying = ref(false);

  /**
   * 텍스트를 클립보드에 복사
   * @param {string} text
   * @returns {Promise<boolean>} 성공 여부
   */
  async function copy(text) {
    copying.value = true;
    try {
      // 1차: navigator.clipboard (HTTPS 환경)
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
      // 2차: document.execCommand fallback (non-HTTPS)
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const success = document.execCommand('copy');
      document.body.removeChild(textarea);
      return success;
    } catch (_e) {
      return false;
    } finally {
      copying.value = false;
    }
  }

  return { copy, copying };
}
